































import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component} from "vue-property-decorator";
import {WardStore} from "@/modules/regionsv2/ward/store";
import {FormModel} from "ant-design-vue";
import DistrictSelectorV2 from "@/modules/regionsv2/DistrictSelectorV2/index.vue";
import ProvinceSelectorV2 from "@/modules/regionsv2/ProvinceSelectorV2/index.vue";

const form = {
    name: undefined,
    districtId: undefined,
    provinceId: undefined
}
@Component({
    name: "WardForm",
    components: {ProvinceSelectorV2, DistrictSelectorV2}
})
export default class extends mixins(CommonMixin) {
    form = { ...form };
    rules = {
        name: [{ required: true, message: "Nhập tên phường/xã" }],
        districtId: [{ required: true, message: "Chọn phường/xã" }],
    }
    submit() {
        (this.$refs.form as FormModel).validate(async (valid) => {
            if (!valid) return;
            try {
                await WardStore.createWardV21(this.form);
                this.resetForm();
                this.$message.success("Tạo phường/xã thành công");
            } catch (e) {
                this.$message.success("Tạo phường/xã thất bại");
            }
        })
    }
    resetForm() {
        this.form = { ...form };
    }
}
